import React from 'react';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
    queryCache: new QueryCache({
        onError: (error) => {
            console.error(error.message);
        },
    }),
});

export function QueryProvider({ children }: { children: React.ReactNode }): React.ReactElement {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <div css={{ fontSize: '16px' }}>
                <ReactQueryDevtools initialIsOpen={false} />
            </div>
        </QueryClientProvider>
    );
}
